import { getCsrfValue } from "../../api/ApiHelper";
import { resolveApiUrl } from "../../utils/url/urlResolver";

interface EndpointProps {
  wishlistId?: string;
  wishlistName?: string;
  products: {
    code: string;
    quantity: number;
  }[];
}

const apiUrl = resolveApiUrl("/wishlist/addEntry/bulk");

export async function bulkAddToWishlist(data: EndpointProps) {
  if (data.products.length < 1) {
    // Sanity check
    return;
  }

  return fetch(apiUrl, {
    body: JSON.stringify({
      id: data.wishlistId,
      wishlistName: !data.wishlistId ? data.wishlistName : undefined,
      products: data.products,
    }),
    method: "POST",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res;
  });
}
